import React, { Suspense } from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/client';
import SellerGroupModelList from './SellerGroupModelList';
import ReactDOM from 'react-dom';
const QUERY = gql `
  query SellerGroupModelListLoaderQuery(
    $sellerContactId: String
    $sellerModelId: String
    $sellerProductGroupId: Int
    $offset: Int
    $limit: Int
    $sellerModelNumber: String
    $specs: String
    $stocks: String
    $price: String
    $shippingDate: String
  ) {
    searchSeller {
      searchSellerGroup(
        sellerContactId: $sellerContactId
        sellerModelId: $sellerModelId
        sellerProductGroupId: $sellerProductGroupId
        offset: $offset
        limit: $limit
        sellerModelNumber: $sellerModelNumber
        specs: $specs
        stocks: $stocks
        price: $price
        shippingDate: $shippingDate
      ) {
        models {
          sellerProductGroupId
          sellerProductGroupName
          sellerModelId
          sellerContactId
          sellerModelNumber
          price
          stocks
          shippingDate
          salesMethodMaker
          openPrice
          salesMethod
          salesMethodLabel
          specs {
            specId
            specName
            specValue
          }
          groupSpecs {
            specId
            specName
            specValue
          }
          allModelSpecsIsPresentInGroup
        }
        groups {
          sellerProductGroupId
          sellerProductGroupName
          sellerModelId
        }
        pageMetadata {
          totalRecords
          currentPage
          recordsFrom
          recordsTo
          noOfPages
          took
          prevPage
          nextPage
          maxNoOfPageToDisplay
        }
      }
    }
  }
`;
const SellerGroupModelListLoader = (props) => {
    let { loading, error, data, refetch, fetchMore } = useQuery(QUERY, {
        variables: {
            sellerContactId: props.sellerContactId,
            sellerModelId: props.sellerModelId,
        },
    });
    if (loading)
        return (React.createElement("div", { className: "seller-product-group-list-container" },
            React.createElement("div", null, "Loading")));
    if (error)
        return (React.createElement("div", { className: "seller-product-group-list-container" },
            React.createElement("div", null, error.message)));
    return (React.createElement("div", { className: "seller-product-group-list-container" },
        React.createElement(SellerGroupModelList, { sellerContactId: props.sellerContactId, sellerModelId: props.sellerModelId, searchSeller: data.searchSeller, refetch: refetch })));
};
export default SellerGroupModelListLoader;
const renderSellerGroupModelList = (apolloClient) => {
    const sellerProductGroupListComponent = document.getElementById('aperza-seller-group-models-component');
    if (sellerProductGroupListComponent) {
        let sellerContactId = sellerProductGroupListComponent.dataset.sellerContactId;
        let sellerModelId = sellerProductGroupListComponent.dataset.sellerModelId;
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(SellerGroupModelListLoader, { sellerContactId: sellerContactId, sellerModelId: sellerModelId }))), sellerProductGroupListComponent);
    }
};
export { renderSellerGroupModelList };
